import { Controller } from '@hotwired/stimulus'

// Turns a GET form whose action is an index path into a "go to record" search: on submit it checks
// `{action}/{id}/validation_of_existence` and redirects to the show page (`{action}/{id}`) when the
// record exists. When it does not, it reports the notFoundMessage through the input's native
// validation bubble instead of submitting to the index.
//
// Targets:
//   input — the text field holding the ID
//
// Values:
//   notFoundMessage (String) — localized message shown when the ID does not exist
//
// Usage:
//   <form action="/movings" method="get"
//         data-controller="search-by-id"
//         data-search-by-id-not-found-message-value="ID no encontrado"
//         data-action="submit->search-by-id#search">
//     <input type="text" data-search-by-id-target="input"
//            data-action="input->search-by-id#clearError" required>
//   </form>
export default class extends Controller {
  static targets = ['input']
  static values = { notFoundMessage: String }

  async search(event) {
    event.preventDefault()

    const id = this.inputTarget.value.trim()
    if (!id) return

    try {
      const encodedId = encodeURIComponent(id)
      const response = await fetch(`${this.element.action}/${encodedId}/validation_of_existence`)
      if (!response.ok) throw new Error('not found')

      window.location.assign(`${this.element.action}/${encodedId}`)
    } catch {
      this.inputTarget.setCustomValidity(this.notFoundMessageValue)
      this.inputTarget.reportValidity()
    }
  }

  clearError() {
    this.inputTarget.setCustomValidity('')
  }
}
